import apiClient from './api';

export const authService = {
  // Login - usa DNI y password
  login: async (credentials) => {
    // credentials debe tener: { dni, password }
    const response = await apiClient.post('/auth/login', credentials);
    return response.data;
  },

  // Registro - incluye email obligatorio
  register: async (userData) => {
    // userData debe tener: { name, lastname, email, password, dni, rol, supervisorId? }
    const response = await apiClient.post('/auth/register', userData);
    return response.data;
  },

  // Validar token (retorna true/false)
  validateToken: async (token) => {
    const response = await apiClient.post('/auth/validate', null, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  // Cambiar contraseña (autenticado)
  changePassword: async (passwordData) => {
    const response = await apiClient.put('/auth/change-password', passwordData);
    return response.data;
  },

  // Solicitar código de recuperación (olvidó contraseña)
  forgotPassword: async (email) => {
    const response = await apiClient.post('/auth/forgot-password', { email });
    return response.data;
  },

  // Resetear contraseña (sin autenticar, por email y código)
  resetPassword: async (resetData) => {
    const response = await apiClient.put('/auth/reset-password', resetData);
    return response.data;
  },
};

export default authService;
